import {Component, OnInit} from '@angular/core';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'sym-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  endPoint = environment.api.loginAPI
  forgotPasswordPopupFields = {
    userLabel: 'Email',
    mainText: 'Reset Password',
    secondaryText: 'Enter your details below to receive your verification code.',
    imageSrc: '../../../assets/logos/saCentre.png',
    successLink: 'login/forgot-password',
    logoStyle: {
      'object-fit': 'contain',
      'height': '130px'
    },
    outerWidth: '700px'
  }

  logoStyle = {
    'object-fit': 'contain',
    'height': '130px'
  };

  constructor() {
    localStorage.clear();
    sessionStorage.clear();
  }

  ngOnInit(): void {
  }

  displayErrorState(status: string) {
  }

  displayErrorMessage(status: string) {
    // TODO
  }

//
  getUser($event) {
    sessionStorage.setItem('isLogged', 'true')
    sessionStorage.setItem('loggedIn', $event);
  }

}
